import React, { useState, useMemo } from "react";
import { Upload, Image, Button as AntButton } from "antd";
import { Button, Wrapper } from "./style";
import CloudAdd from "../../../assets/icons/CloudIcon/cloud-add";
import { generateUniqueKey } from "../../../utils/uniqueKeyGenerator";
import Label from "../style";
import { useShowAlert } from "../../../hooks";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const ImageUpload = ({
  fileList = [],
  setFileList,
  status,
  maxCount,
  multiple,
  label,
  accept,
  acceptTitle,
  onDelete,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const { error } = useShowAlert();

  const filesList = useMemo(() => {
    return fileList.map((value) => {
      if (typeof value === "string") {
        return {
          uid: generateUniqueKey(),
          name: value.slice(-17),
          url: value,
        };
      }
      return value;
    });
  }, [fileList]);

  const handleChange = ({ fileList: newFileList }) => {
    const maxFileSize = 2 * 1024 * 1024;
    const filteredFiles = newFileList?.filter((file) => {
      if (!file.size) {
        return file;
      } else {
        if (file?.size <= maxFileSize) {
          return file;
        } else {
          error("Har bir fayl hajmi 2MB dan oshmasligi kerak!");
        }
      }
    });
    setFileList(filteredFiles);
    // setFileList(newFileList);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  return (
    <Wrapper>
      <Label title={label ? label : "Rasm"} />
      <Upload
        multiple={multiple}
        maxCount={maxCount}
        beforeUpload={() => false}
        fileList={fileList ? filesList : undefined}
        onPreview={handlePreview}
        onChange={handleChange}
        accept={accept ? accept : ".png, .jpg"}
        onRemove={onDelete}
        listType="picture"
      >
        <Button $status={status}>
          <CloudAdd />
          <p className="text">
            {acceptTitle ? acceptTitle : "JPEG, PNG, WEBP"} formats, up to 2MB
          </p>
          <AntButton type="dashed">Yuklash</AntButton>
        </Button>
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </Wrapper>
  );
};

export default ImageUpload;
